// Used only when an older API response has no resendCooldownSeconds.
export const DEFAULT_RESEND_COOLDOWN_SECONDS = 30;

// Counts down whole seconds, for the OTP resend cooldown.
export class OtpCountdown {
  remaining = 0;
  private handle: ReturnType<typeof setInterval> | null = null;

  start(seconds: number): void {
    this.stop();
    this.remaining = Math.max(0, Math.floor(seconds));
    if (this.remaining === 0) {
      return;
    }
    this.handle = setInterval(() => {
      this.remaining--;
      if (this.remaining <= 0) {
        this.remaining = 0;
        this.stop();
      }
    }, 1000);
  }

  stop(): void {
    if (this.handle) {
      clearInterval(this.handle);
      this.handle = null;
    }
  }

  get label(): string {
    const minutes = Math.floor(this.remaining / 60);
    const seconds = this.remaining % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}

// The send-OTP APIs return the cooldown from the IM's OTP policy (IMOTPPolicy).
export function readResendCooldownSeconds(res: any): number {
  const value = Number(res?.resendCooldownSeconds ?? res?.otpResendCooldownSeconds ?? DEFAULT_RESEND_COOLDOWN_SECONDS);
  return Number.isFinite(value) ? value : DEFAULT_RESEND_COOLDOWN_SECONDS;
}

export function readValiditySeconds(res: any, fallbackSeconds: number): number {
  const value = Number(res?.validitySeconds ?? res?.otpValiditySeconds ?? fallbackSeconds);
  return Number.isFinite(value) && value > 0 ? value : fallbackSeconds;
}
